module.exports = __webpack_public_path__ + "img/monocafe.e6ec4f50.jpg";